{
  "labelsPodatki": {
    "email": "Email address",
    "naslov": "Address",
    "posta": "Postal code",
    "kraj": "City",
    "telefon": "Phone",
    "licenca": "License",
    "buttons": {
      "odpri": "Edit pilot profile",
      "posodobi": "update"
    }
  },
  "obvestila": {
    "napakaBranja": "Error reading data.",
    "napakaInputa": "The code field must not be empty!",
    "vprasanjeIzklopa": "Are you sure you want to disable 2FA?",
    "izklopUspesen": "2FA successfully disabled.",
    "vklopUspesen": "2FA successfully enabled.",
    "niUjemanja": "The entered code does not match. Please check the code and try again!"
  }
}